<template>
    <div>
        <div v-if="!initialized && busy"><i class="icon-spinner2 spinner"></i></div>
        <div v-else-if="purchases" class="card-group-control card-group-control-left">
            <div v-for="(purchase, p_index) in purchases" class="card" style="border-left-width: 10px;" :class="[ 'border-left-' + purchase.status.BackgroundClass.substring(purchase.status.BackgroundClass.indexOf('-') + 1) ]" :key="'p-' + p_index">
                <div class="card-header">
                    <div class="row">
                        <div class="col-auto flex-grow-1">
                            <h6 class="card-title">
                                <a data-toggle="collapse" class="collapsed text-body font-size-base d-block" :href="'#purchase-accordion-' + purchase.ProdPurchaseID" style="padding-left: 35px;">
                                    <div class="row">
                                        <div class="col-auto flex-grow-1" style="max-width: 260px;">
                                            <div class="font-weight-bold">SHT{{ String(purchase.ProdPurchaseID).padStart(6, '0') }}</div>
                                            <div>
                                                <span class="badge" :class="[ 'badge-' + purchase.status.BackgroundClass.substring(purchase.status.BackgroundClass.indexOf('-') + 1) ]">{{ purchase.status.StatusName }}</span>
                                                <span v-if="checkDiff(purchase)" class="ml-1 badge badge-warning"><i class="icon-warning mr-1" style="font-size: 10px;"></i>Avvikelse</span>
                                                <span v-else-if="purchase.StatusID >= 50 && !purchase.ConfirmedTS" class="badge badge-warning"><i class="icon-warning mr-1" style="font-size: 10px;"></i>Ej bekräftad</span>
                                            </div>
                                            <div v-if="purchase.ExtOrderID">Ext: {{ purchase.ExtOrderID }}</div>
                                        </div>
                                        <div class="col-auto flex-grow-1">
                                            <div class="row">
                                                <div class="col-xl-3">
                                                    <div><span class="font-weight-bold">Ansvarig: </span><span v-if="purchase.created_by">{{ purchase.created_by.FullName }}</span></div>
                                                    <div><span class="font-weight-bold">Skapad: </span>{{ formatDateTime(purchase.CreatedTS).substring(0, 16) }}</div>
                                                </div>
                                                <div class="col-xl-3">
                                                    <div><span class="font-weight-bold">Ändrad </span><span v-if="purchase.modified_by">av {{ purchase.modified_by.FullName }}</span></div>
                                                    <div>{{ formatDateTime(purchase.ModifiedTS).substring(0, 16) }}</div>
                                                </div>
                                                <div class="col-xl-3">
                                                    <div><span class="font-weight-bold">Skickad </span><span v-if="purchase.sent_by">av {{ purchase.sent_by.FullName }}</span></div>
                                                    <div>{{ formatDateTime(purchase.SentTS).substring(0, 16) }}</div>
                                                </div>
                                                <div class="col-xl-3">
                                                    <div><span class="font-weight-bold">Antal artiklar: </span>{{ purchase.items.length }}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </h6>
                        </div>
                        <div class="col-auto">
                            <router-link :to="{ name: 'suppliers.purchase', params: { id: purchase.ProdPurchaseID } }" class="btn btn-light"><i class="icon-pencil3 mr-2"></i>Redigera</router-link>
                        </div>
                    </div>
                </div>

                <div :id="'purchase-accordion-' + purchase.ProdPurchaseID" class="collapse">
                    <table class="table table-xxs">
                        <tr>
                            <th>Produkt</th>
                            <th>Status</th>
                            <th>Best. Antal</th>
                            <th>Leveransdatum</th>
                            <th>Lev. Antal</th>
                            <th>Kvitterad av</th>
                            <th>Leveranskommentar</th>
                        </tr>
                        <tr v-for="(item, i_index) in purchase.items" :key="'i-' + i_index">
                            <td>
                                <router-link v-if="item.product" :to="{ name: 'products.edit', params: { id: item.product.ProdID} }">
                                    #{{ item.ProdID }} - {{ (item.product.ProdNameWeb ? item.product.ProdNameWeb : item.product.ProdName) }}<MarkedProductIndicator :prod-id="item.ProdID"/>
                                </router-link>
                                <span v-else>#{{ item.ProdID }} - Unknown product</span>
                            </td>
                            <td>
                                <span v-if="item.derived" class="badge badge-success">Levererad</span>
                                <span v-else-if="purchase.StatusID >= 50" class="badge badge-primary">Beställd</span>
                                <span v-else class="badge badge-danger">Ej Beställd</span>
                                <span v-if="item.derived && item.Antal !== item.derived.Antal" class="ml-1 badge badge-warning"><i class="icon-warning mr-1" style="font-size: 10px;"></i>Avvikelse</span>
                            </td>
                            <td>{{ item.Antal }}</td>
                            <td>{{ (item.derived ? item.derived.CreatedTS.substring(0, 10) : (item.EffectiveTS && item.EffectiveTS !== '0000-00-00 00:00:00' ? item.EffectiveTS.substring(0, 10) + ' (beräknad)' : '-')) }}</td>
                            <td>{{ (item.derived ? item.derived.Antal : '') }}</td>
                            <td>{{ (item.derived && item.derived.created_by ? item.derived.created_by.FullName : '') }}</td>
                            <td>{{ (item.derived && item.derived.Kommentar ? item.derived.Kommentar : '') }}</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import apiClient from '@services/ApiClient';
import { formatDateTime } from '@services/Helpers';

export default {
    name: 'SupplierEditorPurchases',
    props: {
        id: {
            type: String,
            default: '',
        },
    },
    data: () => ({
        initialized: false,
        busy: true,
        purchases: [],
    }),
    mounted() {
        this.getSupplier();
    },
    methods: {
        formatDateTime,
        getSupplier() {
            this.busy = true;
            apiClient.get('/vue/suppliers/purchases?supplier_id=' + this.id)
                .then((response) => {
                    this.purchases = response.data.data;
                })
                .finally(() => {
                    this.initialized = true;
                    this.busy = false;
                });
        },
        checkDiff(purchase) {
            let hasDiff = false;
            if (purchase.items && Array.isArray(purchase.items)) {
                purchase.items.forEach((item) => {
                    if (item.derived && item.Antal !== item.derived.Antal) {
                        hasDiff = true;
                    }
                });
            }

            return hasDiff;
        },
    },
};

</script>
